export default __webpack_public_path__ + "static/media/fon.aa70dfc2.png";